// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamicform_textFieldDiv {
  position: relative;
  width: 100%;
  border-radius: 8px;
  border: 0.8px solid #dcdcdc;
  background-color: white;
  padding:5px 10px;
}

.dynamicform_phoneinput {
  width: 100%;
  border-radius: 8px;
  border: 0.8px solid #dcdcdc;
  background-color: #fff;
}

.dynamicform_label {
  color: #aaaaaa;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 4px;
}

.dynamicform_input {
  color: #7f7f7f;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  border: none;
  outline: none;
  width: 100%;
}

.dynamicform_errorMessage {
  font-size: 8px;
  color: red;
  text-align: left;
  margin-top: 2px;
  margin-bottom: 0;
}

.dynamicform_showPasswordButton {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dynamicform_inputFocused {
  border-color: #5599ff;
}

.dynamicform_inputError {
  border-color: #F41919;
}

.dynamicform_labelFocused {
  color: #5599ff;
}

.dynamicform_labelError {
  color: red;
}

.dynamicform_section{
    margin-top: 20px;
}

.dynamicform_sectionTitle {
  font-family: Roboto;
font-size: 14px;
font-weight: 500;
color: #443F3F;
text-align: left;
}


.dynamicform_container {
    padding: 6px 0;
}

.dynamicform_requiredAsterisk {
  color: red; /* or any other color you prefer */
}`, "",{"version":3,"sources":["webpack://./src/Pages/DynamicForm/viewPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,mBAAmB;AACrB,eAAe;AACf,gBAAgB;AAChB,cAAc;AACd,gBAAgB;AAChB;;;AAGA;IACI,cAAc;AAClB;;AAEA;EACE,UAAU,EAAE,kCAAkC;AAChD","sourcesContent":[".dynamicform_textFieldDiv {\n  position: relative;\n  width: 100%;\n  border-radius: 8px;\n  border: 0.8px solid #dcdcdc;\n  background-color: white;\n  padding:5px 10px;\n}\n\n.dynamicform_phoneinput {\n  width: 100%;\n  border-radius: 8px;\n  border: 0.8px solid #dcdcdc;\n  background-color: #fff;\n}\n\n.dynamicform_label {\n  color: #aaaaaa;\n  font-family: Roboto;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  margin-bottom: 4px;\n}\n\n.dynamicform_input {\n  color: #7f7f7f;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  text-align: left;\n  border: none;\n  outline: none;\n  width: 100%;\n}\n\n.dynamicform_errorMessage {\n  font-size: 8px;\n  color: red;\n  text-align: left;\n  margin-top: 2px;\n  margin-bottom: 0;\n}\n\n.dynamicform_showPasswordButton {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dynamicform_inputFocused {\n  border-color: #5599ff;\n}\n\n.dynamicform_inputError {\n  border-color: #F41919;\n}\n\n.dynamicform_labelFocused {\n  color: #5599ff;\n}\n\n.dynamicform_labelError {\n  color: red;\n}\n\n.dynamicform_section{\n    margin-top: 20px;\n}\n\n.dynamicform_sectionTitle {\n  font-family: Roboto;\nfont-size: 14px;\nfont-weight: 500;\ncolor: #443F3F;\ntext-align: left;\n}\n\n\n.dynamicform_container {\n    padding: 6px 0;\n}\n\n.dynamicform_requiredAsterisk {\n  color: red; /* or any other color you prefer */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
